import { apiPost } from '../_common';

export default {
  generateCargoManifest(shipmentId, orderIds) {
    const request = {
      shipmentId,
      orderIds,
    };

    return apiPost('/magenta/fulfillment/cargo-manifest', request)
      .then(result => result.response);
  },
};
